export enum Types {
    INIT_USER_PREFERENCES = "initUserPreferences",
    HIDE_SETUP_STEPS = "hideSetupSteps",
    MARK_DATA_ISSUES_SEEN = "markDataIssuesSeen",
    HIDE_TAGS_CALLOUT = "hideTagsCallout",
}
